// shamelessly stolen from https://stackoverflow.com/a/57102881 because date-fns doesn't have a way of getting
// this information, we don't want to install moment, and Intl.Locale hasn't implemented it hardly at all,
// so this is the best we're going to do for a while

export const weekStartsOn = (locale: string): "sat" | "sun" | "mon" => {
  const weekStart = (
    region: string,
    language: string,
  ): "sat" | "sun" | "mon" => {
    const regionSat = "AEAFBHDJDZEGIQIRJOKWLYOMQASDSY".match(/../g);
    const regionSun =
      "AGARASAUBDBRBSBTBWBZCACNCODMDOETGTGUHKHNIDILINJMJPKEKHKRLAMHMMMOMTMXMZNINPPAPEPHPKPRPTPYSASGSVTHTTTWUMUSVEVIWSYEZAZW".match(
        /../g,
      );
    const languageSat = ["ar", "arq", "arz", "fa"];
    const languageSun =
      "amasbndzengnguhehiidjajvkmknkolomhmlmrmtmyneomorpapssdsmsnsutatethtnurzhzu".match(
        /../g,
      );

    return region
      ? regionSun.includes(region)
        ? "sun"
        : regionSat.includes(region)
          ? "sat"
          : "mon"
      : languageSun.includes(language)
        ? "sun"
        : languageSat.includes(language)
          ? "sat"
          : "mon";
  };

  const parts = locale.match(
    /^([a-z]{2,3})(?:-([a-z]{3})(?=$|-))?(?:-([a-z]{4})(?=$|-))?(?:-([a-z]{2}|\d{3})(?=$|-))?/i,
  );
  return weekStart(parts[4], parts[1]);
};
